// GA4 analytics — additive, PII-free. Measurement ID comes from env only.
// If REACT_APP_GA4_MEASUREMENT_ID is absent, runs in log-only mode (app unaffected).
const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || "";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
let initialized = false;

const classifyTrafficSource = (utm) => {
  if (utm.utm_source) return utm.utm_source;
  const ref = (document.referrer || "").toLowerCase();
  if (!ref) return "direct";
  if (ref.includes("instagram") || ref.includes("ig.me")) return "Instagram";
  if (ref.includes("linkedin") || ref.includes("lnkd.in")) return "LinkedIn";
  try { return new URL(document.referrer).hostname.replace(/^www\./, ""); } catch { return "referral"; }
};

export const captureUTM = () => {
  try {
    const p = new URLSearchParams(window.location.search);
    const found = {};
    UTM_KEYS.forEach((k) => { const v = p.get(k); if (v) found[k] = v; });
    if (Object.keys(found).length) sessionStorage.setItem("om_utm", JSON.stringify(found));
  } catch (e) { /* no-op */ }
};

export const getUTM = () => {
  try { return JSON.parse(sessionStorage.getItem("om_utm") || "{}"); } catch { return {}; }
};

export const initAnalytics = () => {
  if (initialized) return;
  initialized = true;
  captureUTM();
  const utm = getUTM();
  if (!GA_ID) {
    window.dataLayer = window.dataLayer || [];
    console.info("[analytics] GA4 disabled (no REACT_APP_GA4_MEASUREMENT_ID) — log-only mode.");
    return;
  }
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, {
    send_page_view: false, // SPA: we emit page_view manually on route change
    ...(Object.keys(utm).length
      ? { campaign: { source: utm.utm_source, medium: utm.utm_medium, name: utm.utm_campaign, content: utm.utm_content, term: utm.utm_term } }
      : {}),
  });
  console.info("[analytics] GA4 initialized:", GA_ID);
};

export const track = (event, params = {}) => {
  const utm = getUTM();
  const payload = { ...utm, traffic_source: classifyTrafficSource(utm), ...params };
  console.info(`[analytics] event: ${event}`, payload); // internal verification log
  try {
    if (window.gtag && GA_ID) window.gtag("event", event, payload);
    else { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event, ...payload }); }
  } catch (e) { /* never break UX */ }
};

export const trackPageView = (path) => {
  track("page_view", { page_path: path, page_location: window.location.href.split("#")[0] });
};
